import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=123b4f7e&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=123b4f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123b4f7e",
  null
  
)

export default component.exports